import { CountryAssessments } from "@app/features/other/genericApiSlice";
import countryCentroids from "../countryCentroids";
import { countryHasAssessments } from "../utils";

const getAssessmentCount = (country: CountryAssessments) =>
  country.years.reduce((sum, y) => sum + y.assessments.length, 0);

/** Short names on the marker; longer names fall back to assessment count */
const getMarkerLabel = (country: CountryAssessments) => {
  const count = getAssessmentCount(country);
  if (country.name.length <= 12) return country.name;
  return count > 0 ? String(count) : country.name.slice(0, 3);
};

export const buildPopupHTML = (country: CountryAssessments): string => {
  const hasAssessments = countryHasAssessments(country);

  const rows = hasAssessments
    ? country.years
      .filter((y) => y.assessments.length > 0)
      .map(
        ({ year, assessments }) => `
          <div class="hih-popup-year-group">
            <span class="hih-popup-year">${year}</span>
            <div class="hih-popup-assessments">
              ${assessments
            .map(
              (a) =>
                `<a href="${a.link}" target="_blank" rel="noopener noreferrer" class="hih-popup-assessment-link">${a.name}</a>`
            )
            .join("")}
            </div>
          </div>`
      )
      .join("")
    : `<p class="hih-popup-empty">No assessments available</p>`;

  return `
    <div class="hih-popup-content">
      <div class="hih-popup-header">
        <strong class="hih-popup-name">${country.name}</strong>
      </div>
      <div class="hih-popup-body">${rows}</div>
    </div>
  `;
};

export const buildFeatures = (countries: CountryAssessments[]): GeoJSON.Feature[] =>
  countries
    .filter((c) => countryCentroids[c.iso_code.toUpperCase()])
    .map((c) => {
      const [lng, lat] = countryCentroids[c.iso_code.toUpperCase()];
      return {
        type: "Feature" as const,
        id: c.iso_code,
        geometry: { type: "Point" as const, coordinates: [lng, lat] },
        properties: {
          name: c.name,
          iso_code: c.iso_code,
          hasAssessments: countryHasAssessments(c),
          label: getMarkerLabel(c),
          popupHTML: buildPopupHTML(c),
        },
      };
    });
